<template>
	<div :class="'mobile-remarkable-point-cont '+(visible ? 'visible' : '')" @click="close">
		<div class="mobile-remarkable-point-stack" data-align="end">
			<base-icon name="e-remove-1" class="pointer" @click="close" />
			<div class="mobile-remarkable-point stack-vertical" data-align="start">
				<!-- <p class="mobile-remarkable-point-title capitalize-first">{{title}}</p> -->
				<div v-if="!secondCont.length && content" class="mobile-remarkable-point-content capitalize-first" v-html="utils.markdownToHtml(content[$i18n.locale] ? content[$i18n.locale] : content)"></div>
				<div v-if="secondCont.length" v-html="secondCont"></div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">

import utils from '@js/utils.js';
import cloneDeep from 'lodash.clonedeep';
import { nextTick } from 'vue';

export default {
	name: 'InterfaceMobileRemPt',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		title: {
			type: [String, Object],
		},
		content: [String, Object],
		obj: {
			type: Object,
		},
		showslot: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			utils,
			secondCont: ''
		}
	},
	watch: {
		async visible(n) {
			if(n) {
				// console.log(document.querySelector(`.remarkable-point-cont[data-id="${this.obj.id}"]`))
				if(this.showslot) {
					this.secondCont = document.querySelector(`.remarkable-point-cont[data-id="${this.obj.id}"] .remarkable-point-text`).innerHTML
					await nextTick()
				}
				this.$el.style.zIndex = 3
				document.body.style.overflow = 'hidden'
			}
		} 
	},
	methods: {
		close() {
			this.$emit('close')
		},
		styleEventListener() {

			let bodyInitialOverflowValue = getComputedStyle(document.body).overflow;

			this.$el.ontransitionend = e => {
				if(e.propertyName == 'opacity' && !this.visible) {
					this.$el.style.zIndex = -1;
					document.body.style.overflow = bodyInitialOverflowValue
				}
			}
		},
	},
	mounted() {
		this.styleEventListener();
	}
}

</script>

<style type="text/css">
	
	.mobile-remarkable-point-cont {
		position: fixed;
		left: 0;
		top: var(--menu-size);
		z-index: -1;
		width: 100%;
		height: 100%;
/*		height: calc(var(--vh, 1vh) * 100);*/
/*		max-height: -webkit-fill-available;*/
		opacity: 0;
		background-color: rgba(0,0,0,0.5);
		transition-property: opacity;
		transition-duration: .5s;
	}

	.mobile-remarkable-point-title {
		font-size: 1.01rem;
		line-height: 160%;
		color: var(--color-gray-text);
	}

	.mobile-remarkable-point-content {
		font-size: 0.9rem;
		line-height: 140%;
	}

	.mobile-remarkable-point-cont.visible {
		opacity: 1;
	}

	.mobile-remarkable-point-stack {
		background-color: var(--color-white);
		position: fixed;
		width: 100%;
		height: fit-content;
		bottom: 0;
	}

	.mobile-remarkable-point-stack .svg-icon {
		position: absolute;
		top: 0.6rem;
		right: 0.6rem;
	}

	.mobile-remarkable-point {
		align-self: flex-start;
    padding: var(--s2);
    max-height: 50vh;
    overflow: scroll;
	}

</style>
